import React from 'react';
import { Link } from 'react-router-dom';
import { FaCheckCircle } from 'react-icons/fa';
import styles from './OrderConfirmation.module.css';

const translations = {
  ar: {
    title: 'تم استلام طلبك بنجاح',
    message: 'شكراً لك على طلبك. سنقوم بمراجعة طلبك والتواصل معك قريباً.',
    backToShop: 'العودة للتسوق',
  },
  en: {
    title: 'Your order has been received!',
    message: 'Thank you for your order. We will review your order and contact you soon.',
    backToShop: 'Back to Shop',
  },
  tr: {
    title: 'Siparişiniz alındı!',
    message: 'Siparişiniz için teşekkürler. Siparişinizi inceleyip yakında sizinle iletişime geçeceğiz.',
    backToShop: 'Alışverişe Dön',
  },
};

function OrderConfirmation({ lang = 'ar' }) {
  const t = translations[lang] || translations['ar'];
  return (
    <div className={styles.confirmation}>
      <div className={styles.card}>
        <div className={styles.icon}>
          <FaCheckCircle />
        </div>
        <h1>{t.title}</h1>
        <p>{t.message}</p>
        <div className={styles.actions}>
          <Link to="/shop" className={styles.shopButton}>
            {t.backToShop}
          </Link>
        </div>
      </div>
    </div>
  );
}

export default OrderConfirmation; 